import ExtendCampaignModal from './ExtendCampaignModal';
import './ExtendCampaignModal.css';

export default ExtendCampaignModal;



// WEBPACK FOOTER //
// ./src/shared/components/ExtendCampaignModal/index.js